import CategoryForm from "./Form";
import CategoriesList from "./List";

export default function CategoriesPage(props: any) {
  return (
    <div className="content_page">
      {(!props.action || props.action === "list") && <CategoriesList />}

      {props.action && ["create", "edit"].includes(props.action) && (
        <CategoryForm action={props.action} />
      )}
    </div>
  );
}
